<ng-container *ngIf="data$ | async as data">
  <ng-container *ngIf="!!data.ferrisWheel; else carouselTemplate">
    <!-- For desktop devices -->
    <app-ferris-wheel-educacional-level [levels]="data.levels"></app-ferris-wheel-educacional-level>
  </ng-container>

  <ng-template #carouselTemplate>
    <!-- For small devices -->
    <app-carousel-educacional-level [levels]="data.levels"></app-carousel-educacional-level>
  </ng-template>
</ng-container>
